import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';
import Event from '../event';
import { formatImage } from '../../../../base/publicMethod/index';

class Poster extends PureComponent {
    static propTypes = {
        videoInfo: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        narrowWindowMode: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            showImg: true,
            isRender: true,
        };
    }
    componentDidMount() {
        const { dispatch } = this.props;

        this.el.addEventListener('click', () => {
            this.trigger('clickInit');
            // 如果是用户点击播放的，则将context中的autoplay改为true
            dispatch({
                type: 'clickPoster',
            });
        });
    }
    show = () => {
        this.setState({
            showImg: true,
        });
    };
    hide = () => {
        this.setState({
            showImg: false,
        });
    };
    destroy = () => {
        this.setState({
            isRender: false,
        });
    };
    render() {
        const { isRender } = this.state;
        const { videoInfo, narrowWindowMode, videoJsOptions } = this.props;

        //  支持自定义poster图片
        // const Background = videoInfo.poster;
        const Background =
            videoJsOptions && videoJsOptions.width && videoJsOptions.height
                ? formatImage(videoInfo.poster, videoJsOptions.width, videoJsOptions.height)
                : videoInfo.poster;

        return isRender ? (
            <div
                style={{ display: this.state.showImg ? 'block' : 'none', height: '100%', width: '100%' }}
                className={`${narrowWindowMode ? styles.narrowWindow : ''}`}
                ref={c => {
                    this.el = c;
                }}>
                <div className={styles.c_video__poster} style={{ backgroundImage: `url(${Background})` }}>
                    <div className={styles.playerbutton} ref={playBtn => (this.playerbutton = playBtn)} />
                </div>
            </div>
        ) : null;
    }
}
Event.mixTo(Poster);
export default Poster;
